// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"UsersList_blockClick_1NCXA"};